import { Badge } from '../../ui/badge';
import { Building2, MapPin, Printer, CalendarClock } from 'lucide-react';
import { formatDate } from '../../../lib/formatDate';

/** Step 4 wizard: riepilogo prima del salvataggio. */
export default function WizardStepRiepilogo({ cliente, validPuntiVendita, validImpianti, validAbbonamenti }) {
  return (
    <div className="space-y-6">
      <p className="text-sm text-muted-foreground">
        Verifica i dati inseriti prima di salvare.
      </p>

      {/* Riepilogo Cliente */}
      <div className="border border-border p-4">
        <h4 className="font-bold text-sm flex items-center gap-2 mb-3">
          <Building2 className="h-4 w-4" />
          Cliente
        </h4>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-sm">
          <div>
            <p className="text-muted-foreground text-xs">Ragione Sociale</p>
            <p className="font-medium">{cliente.ragione_sociale}</p>
          </div>
          <div>
            <p className="text-muted-foreground text-xs">P.IVA</p>
            <p className="font-mono">{cliente.partita_iva || '-'}</p>
          </div>
          <div>
            <p className="text-muted-foreground text-xs">C.F.</p>
            <p className="font-mono">{cliente.codice_fiscale || '-'}</p>
          </div>
          <div>
            <p className="text-muted-foreground text-xs">SDI</p>
            <p className="font-mono">{cliente.sdi || '-'}</p>
          </div>
          <div className="col-span-2">
            <p className="text-muted-foreground text-xs">Sede Legale</p>
            <p>{cliente.indirizzo_legale ? `${cliente.indirizzo_legale}, ${cliente.cap_legale} ${cliente.citta_legale} ${cliente.provincia_legale}` : '-'}</p>
          </div>
          <div>
            <p className="text-muted-foreground text-xs">Telefono</p>
            <p>{cliente.telefono || '-'}</p>
          </div>
          <div>
            <p className="text-muted-foreground text-xs">Email</p>
            <p>{cliente.email || '-'}</p>
          </div>
        </div>
      </div>

      {/* Riepilogo Punti Vendita */}
      <div className="border border-border p-4">
        <h4 className="font-bold text-sm flex items-center gap-2 mb-3">
          <MapPin className="h-4 w-4" />
          Punti Vendita
          <Badge variant="outline" className="rounded-none ml-2">{validPuntiVendita.length}</Badge>
        </h4>
        {validPuntiVendita.length === 0 ? (
          <p className="text-sm text-muted-foreground">Nessun punto vendita</p>
        ) : (
          <div className="space-y-2">
            {validPuntiVendita.map((pv, index) => (
              <div key={`${pv.nome}-${index}`} className="flex justify-between items-center bg-muted p-2 text-sm">
                <div>
                  <span className="font-medium">{pv.nome}</span>
                  <span className="text-muted-foreground ml-2">- {pv.indirizzo}, {pv.citta}</span>
                </div>
                {pv.referente_nome && <span className="text-xs text-muted-foreground">Ref: {pv.referente_nome}</span>}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Riepilogo Impianti */}
      <div className="border border-border p-4">
        <h4 className="font-bold text-sm flex items-center gap-2 mb-3">
          <Printer className="h-4 w-4" />
          Impianti
          <Badge variant="outline" className="rounded-none ml-2">{validImpianti.length}</Badge>
        </h4>
        {validImpianti.length === 0 ? (
          <p className="text-sm text-muted-foreground">Nessun impianto</p>
        ) : (
          <div className="space-y-2">
            {validImpianti.map((imp, index) => (
              <div key={`${imp.matricola || imp.tipo}-${index}`} className="flex justify-between items-center bg-muted p-2 text-sm">
                <div>
                  <span className="font-mono">{imp.matricola}</span>
                  <span className="text-muted-foreground ml-2">- {imp.tipo} {imp.marca}</span>
                </div>
                {imp.abbonamento_attivo && (
                  <Badge className="rounded-none bg-success/20 text-success text-xs">Con abbonamento</Badge>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Riepilogo Abbonamenti */}
      {validAbbonamenti.length > 0 && (
        <div className="border border-border p-4">
          <h4 className="font-bold text-sm flex items-center gap-2 mb-3">
            <CalendarClock className="h-4 w-4" />
            Abbonamenti
            <Badge variant="outline" className="rounded-none ml-2">{validAbbonamenti.length}</Badge>
          </h4>
          <div className="space-y-2">
            {validAbbonamenti.map((imp, index) => (
              <div key={`${imp.matricola || 'abb'}-${index}`} className="flex justify-between items-center bg-muted p-2 text-sm">
                <div>
                  <span>{imp.abbonamento_descrizione || `Assistenza ${imp.tipo}`}</span>
                  <span className="text-muted-foreground ml-2">({imp.matricola})</span>
                </div>
                <div className="text-right">
                  <span className="font-mono">{imp.abbonamento_importo ? `${imp.abbonamento_importo} EUR` : '-'}</span>
                  <span className="text-muted-foreground text-xs ml-2">
                    scade: {formatDate(imp.abbonamento_data_scadenza)}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
